import t from "@warden-ui/i18n";

export const passwordValidations = [
  {
    name: "length",
    message: t("change_password.validation.minimum_length"),
    isValid: (password: string) => password.length >= 8,
  },
  {
    name: "uppercase",
    message: t("change_password.validation.uppercase"),
    isValid: (password: string) => (/[A-Z]/.test(password)),
  },
  {
    name: "lowercase",
    message: t("change_password.validation.lowercase"),
    isValid: (password: string) => (/[a-z]/.test(password)),
  },
  {
    name: "number",
    message: t("change_password.validation.number"),
    isValid: (password: string) => (/\d/.test(password)),
  },
  {
    name: "special",
    message: t("change_password.validation.special_character"),
    // eslint-disable-next-line no-useless-escape
    isValid: (password: string) => (/[!@#$%&*)(+=._\-\^\]\*]/.test(password)),
  },
];

export const isValidPassword = (password: string) => {
  return passwordValidations.every((validation) => validation.isValid(password));
};